import top from "@/pages/global/components/top-bar/top-bar.vue";
import navigation from "@/pages/global/components/nav-bar/nav-bar.vue";
import bottom from "@/pages/global/components/bottom-bar/bottom-bar.vue";

import UsersCustomHits from '@/pages/administration/admin/app-tags/components/tags-custom-hit/tags-custom-hit.vue';
import { fbFunctions } from "@/config/firebase";

import {
    AisInstantSearch,
    AisRefinementList,
    AisHits,
    AisHighlight,
    AisSearchBox,
    AisStats,
    AisPagination,
    AisSortBy,
    AisHitsPerPage,
} from 'vue-instantsearch';
import algoliasearch from 'algoliasearch/lite';
import 'instantsearch.css/themes/algolia-min.css';
import {i18n} from "../../../../../i18n";
import router from '@/router'

export default {
    data() {
        return {
           searchClient: algoliasearch(
                (location.hostname === "localhost") ? 'L48UIMMJKB' : 'NFR2QQSBTT',
                (location.hostname === "localhost") ? 'ce57f03c4e083aafc111c4ef0702032d' : 'd9ba91603e4e9e4fe0db95e6ec72cfba'
            ),
            tagType: "",
        };
    },
    components: {
        top,
        navigation,
        bottom,
        AisInstantSearch,
        AisRefinementList,
        AisHits,
        AisHighlight,
        AisSearchBox,
        AisStats,
        AisPagination,
        AisSortBy,
        AisHitsPerPage,
        UsersCustomHits,
    },
    methods: {
        generateNewTag() {
            let vm = this;

            if(vm.tagType !== "" && vm.tagType != null) {
                let saveMaintenanceMode = fbFunctions.httpsCallable('apiAdmin');
                Swal.fire(
                    i18n.t("administration.admin.app_tags.modal_creation_in_progress_title"),
                    i18n.t("administration.admin.app_tags.modal_creation_in_progress_subtitle"),
                    "warning"
                );
                saveMaintenanceMode({
                    type: 'generateNewTag',
                    parameters: {
                        type: vm.tagType,
                    }
                })
                .then(function(result) {
                    if(result.data.code === "TAG_SUCCESSFULLY_CREATED") {
                        swal.fire(
                            i18n.t("administration.admin.app_tags.modal_success_tag_created_title"),
                            i18n.t('administration.admin.app_tags.modal_success_tag_created_subtitle', {
                                'activationCode': result.data.activationCode,
                                'id': result.data.id
                            }),
                            "success"
                        )
                        router.push('dashboard')
                    }
                    else {
                        swal.fire(
                            i18n.t("administration.admin.global.modal_generic_error_title"),
                            i18n.t("administration.admin.global.modal_generic_error_content"),
                            "error"
                        )
                    }
                })
                .catch((e) => {
                    swal.fire(
                        i18n.t("administration.admin.global.modal_generic_error_title"),
                        i18n.t("administration.admin.global.modal_generic_error_content"),
                        "error"
                    )
                });
            }
            else {
                swal.fire(
                    i18n.t("administration.admin.app_tags.modal_incorrect_tag_type_title"),
                    i18n.t("administration.admin.app_tags.modal_incorrect_tag_type_content"),
                    "error"
                )
            }

        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/administration/admin/app-tags/master/app-tags.js